import { z } from 'zod';

export const loginSchema = z.object({
  username: z
    .string()
    .min(1, 'Username is required')
    .min(3, 'Username must be at least 3 characters'),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(6, 'Password must be at least 6 characters'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const warehouseItemSchema = z.object({
  id: z.string().optional(),
  name: z
    .string()
    .min(1, 'Item name is required')
    .max(100, 'Item name must be less than 100 characters'),
  sku: z
    .string()
    .min(1, 'SKU is required')
    .regex(/^[A-Z0-9-]+$/, 'SKU must contain only uppercase letters, numbers, and hyphens'),
  quantity: z
    .number()
    .min(0, 'Quantity must be positive')
    .max(99999, 'Quantity must be less than 99999'),
  location: z
    .string()
    .min(1, 'Location is required')
    .max(50, 'Location must be less than 50 characters'),
  description: z
    .string()
    .max(500, 'Description must be less than 500 characters')
    .optional(),
});

export type WarehouseItemFormData = z.infer<typeof warehouseItemSchema>;